import { storefrontRuntimeHttpClient, storefrontZipcodeServicesHttpClient } from '../../utils/HttpClient'

import { ProductArrivalDetailsType } from './zipCodeService.types'

export const getZipCodeForUser = async (): Promise<string> => {
  try {
    const { data } = await storefrontZipcodeServicesHttpClient.get('/get-zip-code')
    return data
  } catch (e) {
    console.error('Failed while fetching user zip code getZipCodeForUser() runtime, API - /get-zip-code')
  }
  return ''
}

export const getIsValidUsZipcode = async (zipcode?: string) => {
  const { data: isValid } = await storefrontRuntimeHttpClient.get<boolean>('/get-delivery-date-eligibility', {
    params: {
      zipCode: zipcode,
    },
  })
  return isValid
}

export const getPDPDynamicContents = async (
  zipcode: string,
  allProductIdsVsVariantIdsMap: Record<number, number[]>,
): Promise<Record<string, ProductArrivalDetailsType>> => {
  try {
    const { data } = await storefrontRuntimeHttpClient.post('/get-pdp-dynamic-contents', {
      zipCode: zipcode,
      products: allProductIdsVsVariantIdsMap,
    })
    return data
  } catch (error) {
    console.error(
      'Failed while fetching user PDP dynamic content getPDPDynamicContents() runtime, API - /get-pdp-dynamic-contents',
    )
    return {}
  }
}
